import { createAction, props } from '@ngrx/store';
import {
  ECampaignPaginationType,
  ECampaignsActions,
  ECampaignType,
  ICampaign,
  ICampaignListingPagination,
  ICampaignPagination,
  IDates,
  IDatesPagination,
} from '../models/campaigns.model';

export const loadCampaigns = createAction(
  ECampaignsActions.LOAD_CAMPAIGNS,
  props<{
    pagination: ICampaignPagination;
    activePagination?: ICampaignListingPagination;
  }>(),
);

export const loadCampaignsSuccess = createAction(
  ECampaignsActions.LOAD_CAMPAIGNS_SUCCESS,
  props<{
    active_campaigns: ICampaign[];
    pending_campaigns: ICampaign[];
    deleted_campaigns: ICampaign[];
    pagination: ICampaignListingPagination;
  }>(),
);

export const loadCampaignsError = createAction(
  ECampaignsActions.LOAD_CAMPAIGNS_ERROR,
  props<{ error: any }>(),
);

export const changePage = createAction(
  ECampaignsActions.CHANGE_PAGE,
  props<{
    page: number;
    campaign_type: ECampaignPaginationType;
    page_size: number;
  }>(),
);

export const changePageSuccess = createAction(
  ECampaignsActions.CHANGE_PAGE_SUCCESS,
  props<{
    campaign_type: ECampaignPaginationType;
    items: ICampaign[];
    pagination: ICampaignPagination;
  }>(),
);

export const updateCampaign = createAction(
  ECampaignsActions.UPDATE_CAMPAIGN,
  props<{ campaign: ICampaign }>(),
);

export const updateCampaignSuccess = createAction(
  ECampaignsActions.UPDATE_CAMPAIGN_SUCCESS,
  props<{ response: any }>(),
);

export const updateCampaignError = createAction(
  ECampaignsActions.UPDATE_CAMPAIGN_ERROR,
  props<{ error: any }>(),
);

export const refreshCampaigns = createAction(
  ECampaignsActions.REFRESH_CAMPAIGNS,
  props<{ pagination: ICampaignListingPagination }>(),
);

export const getCampaignInfo = createAction(
  ECampaignsActions.GET_CAMPAIGN_INFO,
  props<{ campaign_id: number }>(),
);

export const getCampaignInfoSuccess = createAction(
  ECampaignsActions.GET_CAMPAIGN_INFO_SUCCESS,
  props<{ campaign: ICampaign }>(),
);

export const getCampaignInfoError = createAction(
  ECampaignsActions.GET_CAMPAIGN_INFO_ERROR,
  props<{ error: any }>(),
);

export const createCampaign = createAction(
  ECampaignsActions.CREATE_CAMPAIGN,
  props<{
    campaign_name: string;
    campaign_type: ECampaignType;
    campaign_frequency: number;
  }>(),
);

export const createCampaignSuccess = createAction(
  ECampaignsActions.CREATE_CAMPAIGN_SUCCESS,
  props<{ campaign_id: number }>(),
);

export const createCampaignError = createAction(
  ECampaignsActions.CREATE_CAMPAIGN_ERROR,
  props<{ error: any }>(),
);

export const deleteCampaign = createAction(
  ECampaignsActions.DELETE_CAMPAIGN,
  props<{ campaign: ICampaign }>(),
);

export const deleteCampaignSuccess = createAction(
  ECampaignsActions.DELETE_CAMPAIGN_SUCCESS,
  props<{ response: any }>(),
);

export const deleteCampaignError = createAction(
  ECampaignsActions.DELETE_CAMPAIGN_ERROR,
  props<{ error: any }>(),
);

export const restoreCampaign = createAction(
  ECampaignsActions.RESTORE_CAMPAIGN,
  props<{ campaign: ICampaign }>(),
);

export const restoreCampaignSuccess = createAction(
  ECampaignsActions.RESTORE_CAMPAIGN_SUCCESS,
  props<{ response: any }>(),
);

export const restoreCampaignError = createAction(
  ECampaignsActions.RESTORE_CAMPAIGN_ERROR,
  props<{ error: any }>(),
);

// Blocked dates actions

export const loadBlockedDates = createAction(
  ECampaignsActions.LOAD_BLOCKED_DATES,
  props<{ pagination: IDatesPagination }>(),
);

export const loadBlockedDatesSuccess = createAction(
  ECampaignsActions.LOAD_BLOCKED_DATES_SUCCESS,
  props<{
    items: IDates[];
    current_page?: number;
    has_more_data?: boolean;
    page_size?: number;
    total_pages_count?: number;
    has_previous?: boolean;
    total_count?: number;
    extra_data?: string[]
  }>(),
);

export const loadBlockedDatesError = createAction(
  ECampaignsActions.LOAD_BLOCKED_DATES_ERROR,
  props<{ error: any }>(),
);

export const createDate = createAction(
  ECampaignsActions.CREATE_DATE,
  props<{ dates: IDates[]; isManager: boolean; accountId: number }>(),
);

export const createDateSuccess = createAction(
  ECampaignsActions.CREATE_DATE_SUCCESS,
  props<{ response: any }>(),
);

export const createDateError = createAction(
  ECampaignsActions.CREATE_DATE_ERROR,
  props<{ error: any }>(),
);

export const deleteDate = createAction(
  ECampaignsActions.DELETE_DATE,
  props<{ dates: IDates[] }>(),
);

export const deleteDateSuccess = createAction(
  ECampaignsActions.DELETE_DATE_SUCCESS,
  props<{ response: any }>(),
);

export const deleteDateError = createAction(
  ECampaignsActions.DELETE_DATE_ERROR,
  props<{ error: any }>(),
);

export const refreshDates = createAction(
  ECampaignsActions.REFRESH_DATES,
  props<{ pagination: IDatesPagination }>(),
);

export const changeDatesPage = createAction(
  ECampaignsActions.CHANGE_DATES_PAGE,
  props<{ page: number; page_size: number }>(),
);

export const changeDatesPageSuccess = createAction(
  ECampaignsActions.CHANGE_DATES_PAGE_SUCCESS,
  props<{
    items: IDates[];
    pagination: IDatesPagination;
  }>(),
);
